import SessionExpired from 'utils/session_expired';

export function handleApiError(message, error) {
  if (error?.status === 401) {
    return SessionExpired.renewSessionModal(location.href);
  }

  if (error?.status === 422) return;

  toastr.error(message || 'Ocorreu um erro, tente novamente.');

  if (!error?.errors) {
    // So reporta falhas de servidor reais. Status ausente (abort/rede), 403
    // (challenge da Cloudflare / forbidden), 408 (timeout) e 429 (rate limit)
    // sao esperados e inflavam os itens genericos #399359/#399354 sem dado
    // acionavel. O toastr (UX) ja foi exibido acima.
    const status = error?.status;
    const isExpected =
      !status || status === 403 || status === 408 || status === 429;

    if (message && !isExpected) Rollbar.error(message, error);
    return;
  }

  const errorKey = Object.keys(error.errors)[0];
  if (!errorKey) return;

  const errorMsgs = error.errors[errorKey];
  const errorMsg = (errorMsgs.length && errorMsgs[0]) || '';

  Rollbar.error(
    `API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`,
    {
      status: error.status,
      statusText: error.statusText,
      responseText: error.responseText
    }
  );
}
